import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, AccountActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Terminals;
const IdentitySelector = (state) => state.Identity;

const MerchantList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { mlist, nowWainting } = useSelector(merchantsSelector);
    const { token, userData } = useSelector(IdentitySelector);

    const { classes } = props;

    // 一覧のフィルタリング要素の復元用
    var merchantName = props.merchantNameSearch;    // 加盟店名
    var merchantType = props.merchantTypeSearch;    // 加盟店タイプ

    const listDefinition = {
        columns: [
            {
                title: <FormattedMessage id="Terminal.Merchant.Name" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantNameSearch,
            },
            {
                title: <FormattedMessage id="Terminal.Merchant.Type" />,
                field: 'merchant_type',
                lookup: {
                    acquirer: '代表',
                    general: '一般',
                },
                filtering: true,
                defaultFilter: props.merchantTypeSearch,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {

        merchantName = '';
        merchantType = '';

        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'merchant_name') {
                    merchantName = filter[i].value;
                } else if (filter[i].column.field == 'merchant_type') {
                    merchantType = filter[i].value;
                }
            };
        }
    }

    /**
     *
     * 初期表示処理
     * （システム管理者、沖縄IC、代表加盟店の場合のみ加盟店一覧表示）
     *
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {
            if (userData) {
                if (userData.role == 1 || userData.role == 2) {
                    // システム管理者、沖縄ICユーザの場合は代表加盟店と加盟店の一覧を表示
                    accountActions.listMerchants(token)
                        .then(data => {
                        })
                        .catch(e => {
                            notificationActions.showError(e.message);
                        });
                } else {
                    // 代表加盟店ユーザの場合は加盟店の一覧を表示
                    accountActions.listGeneralMerchants(token)
                        .then(data => {
                        })
                        .catch(e => {
                            notificationActions.showError(e.message);
                        });
                }
            }
        }
    }, []);

    /**
     * 
     * 一覧の詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onListlClick = (data) => {
        props.onList(data, merchantName, merchantType);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="Account.MerchantList" />}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={mlist}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onListlClick(actionProps.data, merchantName, merchantType)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        }
                        else {
                            return (
                                <input type="hidden" value="" />
                            )
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantList);
